import { FC } from 'react';

import { CountryEntity } from 'api/types/entity';
import { isFinanceProject, isGlobalProject } from 'config';
import { useFormErrorFocus } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  CitizenshipSection,
  PepConnectionSection,
  TaxResidencySection,
  ReasonAddSection,
  RegistrationAndResidentialAddressSection,
  LegalClientAddHeadPositionSection,
  PlaceOfBirthAndResidentialAddressSection,
} from 'modules/client/common/components/sections';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';

import { IdentityDocumentSection, PersonalDataSection } from '../sections';

export interface LegalClientAddFirstHeadSectionsProps {
  countriesLoading?: boolean;
  countries: CountryEntity[];
}

export const LegalClientAddFirstHeadSections: FC<
  LegalClientAddFirstHeadSectionsProps
> = ({ countries, countriesLoading }) => {
  useFormErrorFocus();

  const isFinance = isFinanceProject();
  const isGlobal = isGlobalProject();

  const { t } = useTranslation();

  return (
    <CountryRiskProvider role={CountryRiskRole.LegalClientFirstHead}>
      <Stack spacing={24}>
        <ReasonAddSection />
        <PersonalDataSection />
        {isGlobal && <IdentityDocumentSection />}

        <LegalClientAddHeadPositionSection onlyPosition />
        <CitizenshipSection
          countries={countries}
          countriesLoading={countriesLoading}
        />
        <TaxResidencySection
          countries={countries}
          countriesLoading={countriesLoading}
        />
        {isFinance && (
          <RegistrationAndResidentialAddressSection
            countries={countries}
            countriesLoading={countriesLoading}
          />
        )}
        {isGlobal && (
          <PlaceOfBirthAndResidentialAddressSection
            countries={countries}
            countriesLoading={countriesLoading}
          />
        )}
        <PepConnectionSection
          notRequestInformation={isGlobal}
          pepConnectionRelationLabel={t(
            'client.legal.legalClientFirstHead.pepConnection.relation.label'
          )}
        />
      </Stack>
    </CountryRiskProvider>
  );
};
